import React from "react";
import PropTypes from "prop-types";
import { Alert } from "react-bootstrap";
import "../../../assets/scss/_doctor-letter.scss";
import { removeStatusLineFromContent } from "../../../utils/reportUtils";
import DOMPurify from 'dompurify';
/**
 * Generates a status label based on the overall health status.
 */
const getStatusLabel = (status, testName) => {
  if (status === "good") return `Everything looks good with your ${testName}`;
  if (status === "require-attention")
    return `Some results require attention in your ${testName}`;
  if (status === "borderline-high-testosterone")
    return `Your ${testName} returned some borderline high results`;
  return `Your ${testName} returned some borderline results`;
};

/**
 * DoctorLetter component
 * Displays a doctor's letter including the doctor's information,
 * a warning if an assessment is missing, and the letter's main content.
 */
const DoctorLetter = ({
  doctor,
  patient,
  overallStatus,
  content,
  missingAssessment,
  testName,
  isPartialReport
}) => {
  const statusLabel = getStatusLabel(overallStatus, testName);
  const cleanedContent = removeStatusLineFromContent(content, statusLabel);

  return (
    <section className="doctorLetter__container bg-ivory-mist rounded p-4">
      <header className="doctorLetter__doctor">
        <span className="doctorLetter__doctor-name">
          Dear {patient?.split(" ")[0]}
        </span>
      </header>

      {/* Show alert when assessment is missing */}
      {missingAssessment &&
        !JSON.parse(sessionStorage.getItem("phlebotomy")) && (
          <Alert variant="warning" dismissible={false}>
            <small>
              Please note, we have not received your Patient Health Assessment.
              Because of this, your results have not been assessed by our
              doctors in accordance with your health and lifestyle information.
              Therefore, your results are not personalised.
            </small>
          </Alert>
        )}

      {/* Main content */}
      <div className="doctorLetter__main">
        {/* <p className="doctorLetter__lead">Dear {patient?.split(" ")[0]}</p> */}
        <p
          className={`doctorLetter__overview doctorLetter__overview--${overallStatus}`}
        >
          {!isPartialReport && <span>{statusLabel}</span>}
        </p>
        <p
          style={{ color: "#003032" }}
          className="doctorLetter__content"
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(
              cleanedContent.replace(/(?:\r\n|\r|\n)/g, "<br />"),
            ),
          }}
        ></p>
        <p style={{ color: "#003032" }} className="doctorLetter__signature">
          <span className="fw-semibold">Kind Regards,</span> <br />
          <span className="fw-bold"> Dr {doctor}</span>
        </p>
      </div>
    </section>
  );
};
DoctorLetter.propTypes = {
  doctor: PropTypes.string.isRequired,
  patient: PropTypes.string,
  overallStatus: PropTypes.oneOf(['good', 'require-attention', 'borderline', 'borderline-high-testosterone']).isRequired,
  content: PropTypes.string.isRequired,
  missingAssessment: PropTypes.bool,
  testName: PropTypes.string.isRequired,
  isPartialReport: PropTypes.any
};

export default DoctorLetter;
